import {PATH_HISTORY_SINGLE_VOYAGE} from "@constants/navigate";

export const buildPathToHistorySingleVoyage = ({
                                                   voyageId,
                                                   accountId
                                               }: {
    voyageId: number
    accountId: string | number
}): string => {
    return `${PATH_HISTORY_SINGLE_VOYAGE}/${voyageId}?accountId=${accountId}`
}

